<template>
  <div class="modal modal--animate-scale flex flex-center bg-black bg-opacity-90% padding-md js-modal" id="modal-form">
    <div class="modal__content width-100% max-width-xs max-height-100% overflow-auto padding-md bg radius-md inner-glow shadow-md" role="alertdialog" aria-labelledby="modal-form-title" aria-describedby="modal-form-description">
      <div class="text-component margin-bottom-md">
        <h3 id="modal-form-title">{{ $t('cookies_preferences') }}</h3>
        <p id="modal-form-description">{{ $t('cookies_preferences_intro') }}</p>
      </div>

      <QuickList marginBottom="margin-bottom-md" initiator="modal" />

      <div class="text-component">
        <p class="text-xs color-contrast-medium">{{ $t('cookies_preferences_footer') }} <a :href="privacy_policy" class="color-contrast-high" target="_blank">{{ $t('privacy_policy') }}</a>.</p>
      </div>
    </div>

    <button class="reset modal__close-btn modal__close-btn--outer  js-modal__close js-tab-focus">
      <svg class="icon icon--sm" viewBox="0 0 24 24">
        <title>Close modal window</title>
        <g fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="3" y1="3" x2="21" y2="21" />
          <line x1="21" y1="3" x2="3" y2="21" />
        </g>
      </svg>
    </button>
  </div>
</template>

<script>

export default {
  name: 'ConsentModal',
  data() {
    return {
      privacy_policy: ''
    }
  },
  mounted() {
    this.privacy_policy = window.ampsandCookiesPrivacyLink;

    let modalJs = document.createElement('script');
    modalJs.setAttribute('src', 'https://cdn.ampersand.company/js/modal-window.js');
    modalJs.setAttribute('id', 'modal-window-js');
    
    document.body.appendChild(modalJs);
  }
}
</script>

<style lang="scss">
</style>